import React, { useState } from 'react';
import reactHtmlParser from 'react-html-parser';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import PropTypes from 'prop-types';
import './PopOutIcon.scss';
import { Popover } from '@salesforce/design-system-react';

export const PopOutIcon = ({ link, linkArr, className, isDocrio }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const popoverContent = () => {
    return (
      <div className='popOut-popover'>
        {linkArr?.map(({ link, name }, index) => {
          return (
            <div key={index} className='popOut-popover-item' onClick={() => window.open(link)}>
              <p>{reactHtmlParser(name || '')}</p>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={`popOut ${className}`} onClick={(e) => {
      e.stopPropagation();
    }}>
      { link ?
      <Svg
        className={`popOut-icon ${className}`}
        data="../assets/new_window.svg"
        fill={ colors.searchGrey }
        hoverable
        hoverFill={ colors.iconHover }
        tooltipContent={<span>View in {isDocrio ? 'Docrio' : 'Litify'}</span>}
        onClickAction={() => window.open(link)}
      /> :
      <Popover
        body={isModalOpen ? popoverContent() : null}
        id={`popOut-popOver`}
        isOpen={isModalOpen}
        style={{ width: '200px' }}
        align='bottom right'
        onRequestClose={() => setIsModalOpen(false)}
        hasNoCloseButton
        hasNoNubbin
        overlay
      >
        <Svg
          className={`popOut-icon ${className}`}
          data="../assets/new_window.svg"
          fill={ colors.searchGrey }
          hoverable
          hoverFill={ colors.iconHover }
          tooltipContent={<span>View in {isDocrio ? 'Docrio' : 'Litify'}</span>}
          onClickAction={() => setIsModalOpen(true)}
        />
      </Popover>
      }
    </div>
  );
};

PopOutIcon.propTypes = {
  link: PropTypes.string,
  linkArr: PropTypes.object,
  className: PropTypes.string,
  isDocrio: PropTypes.bool,
};
